<template>
  <div class="modal-wrap">
    <div class="content-center position-rel" :class="`content-type-media`">
      <div class="modal-head content-viewer__head">
        <div class="container-fluid">
          <div class="inner-back js-back" @click="handleOffModal">
            <span class="icon-arrow-left font-size-16 color-light position-rel"><span class="path1"></span><span class="path2"></span></span>
          </div>
        </div>
      </div>
      <div 
        id="content_viewer"
        class="inner-img content-viewer"
        :class="`inner-type-media ${relateMedia && relateMedia.length > 0 ? 'has-more' : ''} ${docSlider.linkPages && docSlider.linkPages.length > 1 ? 'multi' : 'single'}`"
      >
        <div class="overlay" @click="handleOffModal"></div>
        <div class="content-viewer__preview full-width" :class="{'multi': docSlider.linkPages && docSlider.linkPages.length > 1}">
          <div class="content-viewer__preview__head">
            <div class="content-viewer__main">
              <PreviewMedia
                v-if="docSlider.linkPages && docSlider.linkPages.length > 0 && mediaMain"
                :dataSource="mediaMain"
                :isRelateMedia="relateMedia && relateMedia.length > 0 ? true : false"
              />
              <p v-else-if="!docSlider.linkPages || docSlider.linkPages.length === 0" class="content-viewer__null font-size-22 secondary-color-txt text-center">Không tìm thấy tài liệu hiển thị</p>
              <div class="content-viewer__info d-md-none d-sm-block info-content">
                <div class="content-viewer__info__wrap display-flex-center justify-content-between">
                  <div class="content-viewer__info__content">
                    <h5 class="media-preview__title font-size-28 color-light">{{ mediaMain.titleLink }}</h5>
                    <p class="media-preview__type font-size-18 color-light font-sanpro-light margin-0 cursor-pointer" @click="showModalReadmore">{{ docSlider.bookPageLinkGroupId === 1 && docSlider.isPublish ? 'Học liệu đã được NXBGDVN phê duyệt' : 'Học liệu Hành trang số sản xuất' }}</p>
                  </div>
                  <div class="content-viewer__info__action">
                    <button type="button" class="btn btn-dark-primary-light border-rd-20 font-size-16" @click="handleShareMedia">
                      <i class="icon-share-white"></i> Chia sẻ
                    </button>
                    <button
                      v-if="docSlider.linkPages && docSlider.linkPages[indexMediaMain] && docSlider.linkPages[indexMediaMain].linkUrl"
                      type="button"
                      href="javascript:;"
                      class="btn btn-dark-primary-light border-rd-50 font-size-16 content-viewer__info__action__help"
                      @click="handleDownloadFile(docSlider.linkPages[indexMediaMain].linkUrl, docSlider.linkPages[indexMediaMain].titleLink)"
                    >
                      <i class="icon-download"></i>
                    </button>
                    <button type="button" class="btn btn-dark-primary-light border-rd-50 font-size-16 content-viewer__info__action__help" @click="openModalError"><i class="icon-help-white"></i></button>
                  </div>
                </div>
              </div>
            </div>
            <div class="content-viewer__list" v-if="docSlider.linkPages && docSlider.linkPages.length > 1">
              <div class="content-viewer__list__head display-flex-center justify-content-between">
                <h3 class="content-viewer__list__title font-size-17 font-sanpro margin-0">Nhóm học liệu</h3>
                <span class="content-viewer__list__count font-sanpro-light">{{ docSlider.linkPages.length }}</span>
              </div>
              <vue-custom-scrollbar class="content-viewer__list__body">
                <div class="item" v-for="(item, index) of docSlider.linkPages" :key="index" :class="{'active': index === indexMediaMain}" @click="viewMediaInDocSlider(index)">
                  <figure class="item__img margin-0 position-rel">
                    <!-- <img :src="item.posterLink ? `${urlImgCms}/${item.posterLink}` : img404" alt="Học liệu"> -->
                    <!-- <img :src="(item.posterLink ? `${urlImgCms}/${item.posterLink}` : `${appUrl}/${item.linkUrl}`) || (item.linkUrl ? `${appUrl}/${item.linkUrl}` : img404)" alt="Học liệu"> -->
                    <img :src="item.posterLink ? `${urlImgCms}/${item.posterLink}` : item.linkUrl ? `${appUrl}/${item.linkUrl}` : img404" alt="Học liệu">
                  </figure>
                  <div class="item__body">
                    <h4 class="item__title font-size-16 font-sanpro color-light">{{ item.titleLink }}</h4>
                    <p class="margin-0 item__meta font-size-13 font-sanpro-light  color-light">
                      <span class="item__meta__type">{{ getTypeMedia(item.linkUrl) }}</span>
                      <span v-if="checkAudio(item.linkUrl) || checkVideo(item.linkUrl)" class="item__meta__duration">{{ getDurationMedia(item.linkUrl) }}</span>
                    </p>
                  </div>
                </div>
              </vue-custom-scrollbar>
            </div>
          </div>
          <div class="content-viewer__preview__body d-md-block d-sm-none mg-mobile">
            <div class="content-viewer__main">
              <div class="content-viewer__info">
                <div class="content-viewer__info__wrap display-flex-center justify-content-between">
                  <div class="content-viewer__info__content">
                    <h5 class="media-preview__title font-size-28 color-light">{{ mediaMain.titleLink }}</h5>
                    <p class="media-preview__type font-size-18 color-light font-sanpro-light margin-0 cursor-pointer" @click="showModalReadmore">{{ docSlider.bookPageLinkGroupId === 1 && docSlider.isPublish ? 'Học liệu đã được NXBGDVN phê duyệt' : 'Học liệu Hành trang số sản xuất' }}</p>
                  </div>
                  <div class="content-viewer__info__action">
                    <button type="button" class="btn btn-dark-primary-light border-rd-20 font-size-16 count-download">
                      <i class="icon-eye"></i>
                      <span class="count-d">{{ docSlider.linkPages[indexMediaMain].countView }}</span>
                    </button>
                    <button
                      v-if="docSlider.linkPages[indexMediaMain].linkUrl || docSlider.linkPages[indexMediaMain].countDownload"
                      type="button"
                      href="javascript:;"
                      class="btn btn-dark-primary-light border-rd-20 font-size-16 content-viewer__info__action__help count-download"
                      @click="handleDownloadFile(docSlider.linkPages[indexMediaMain].linkUrl, docSlider.linkPages[indexMediaMain].titleLink, docSlider.linkPages[indexMediaMain].pageLinksId)"
                    >
                      <i class="icon-download"></i>
                      <span class="count-d">{{ docSlider.linkPages[indexMediaMain].countDownload }}</span>
                    </button>

                    <button type="button" class="btn btn-dark-primary-light border-rd-20 font-size-16" @click="handleShareMedia">
                      <i class="icon-share-white"></i> Chia sẻ 
                    </button>
                    
                    <button type="button" class="btn btn-dark-primary-light border-rd-50 font-size-16 content-viewer__info__action__help" @click="openModalError"><i class="icon-help-white"></i></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="content-viewer__info">
        <div class="media-preview__info">
          <h5 class="media-preview__title font-size-28 color-light">{{ mediaMain.titleLink }}</h5>
          <p class="media-preview__type font-size-18 color-light font-sanpro-light">{{ docSlider.bookPageLinkGroupId === 1 && docSlider.isPublish ? 'Học liệu đã được NXBGDVN phê duyệt' : 'Học liệu Hành trang số sản xuất' }}</p>
        </div>
      </div> -->
      <div class="sidebar__media__list sidebar__media__list--slider position-rel mobile-slide" v-if="relateMedia && relateMedia.length > 0">
        <h3 class="sidebar__media__list__title font-sanpro-semibold color-light font-size-22">Xem thêm</h3>
        <swiper 
          :options="{slidesPerView: 4, spaceBetween: 20, slidesPerGroup: 1, grabCursor: true, loop: false, loopFillGroupWithBlank: true, breakpoints: {767: {slidesPerView: 2, slidesPerGroup: 1, spaceBetween: 10 }, 767: {slidesPerView: 2, slidesPerGroup: 1, spaceBetween: 10 }, 575: {slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 10 } }, navigation: {nextEl: `.ebook__next__0`, prevEl: `.ebook__prev__0`}}"
          @slideNextTransitionEnd="handleNextMedia" 
          ref="swiper_relate"
        >
          <swiperSlide 
            class="item position-rel" 
            v-for="(item, loc) of relateMedia" 
            :key="loc"
            :class="{'item--lock': (!item.isShowFree || item.isShowFree === 0) && !ebooksDetail.isActived, 'item--audio': checkAudio(item.linkUrl)}"
            v-show="item.linkUrl"
          >
            <div class="item__wrap" @click="viewMedia(item)">
              <div class="item__media position-rel">
                <div class="img-wrap text-center">
                  <img v-if="checkVideo(item.linkUrl)" :src="item.posterLink ? `${urlImgCms}/${item.posterLink}` : img404" alt="Học liệu">
                  <PreviewImage
                    v-else-if="checkImage(item.linkUrl)" 
                    :pathView="isFullLink(item.linkUrl) ? item.linkUrl : `${appUrl}${item.linkUrl}`"
                  />
                  <PreviewYoutube
                    v-else-if="checkYoutube(item.linkUrl)"
                    :pathView="item.linkUrl"
                  />
                  <PreviewAudio
                    class="evt-none"
                    v-else-if="checkAudio(item.linkUrl)"
                    :pathView="isFullLink(item.linkUrl) ? item.linkUrl : `${appUrl}${item.linkUrl}`"
                  />
                </div>
                <IconMedia class="item__icon" :dataSource="item" />
              </div>
              <h4 class="item__title font-size-15 color-light margin-0">
                {{ item.title }}
              </h4>
            </div>
          </swiperSlide>
          <div class="button-prev-0 ebook__prev__0 font-size-40" slot="button-prev">
            <div class="clearfix bshadow0 pbs">
              <span class="icon-arrow-left"><span class="path1"></span><span class="path2"></span></span>
            </div>
          </div>
          <div class="button-next-0 ebook__next__0 font-size-40" slot="button-next">
            <div class="clearfix bshadow0 pbs">
              <span class="icon-arrow-right"><span class="path1"></span><span class="path2"></span></span>
            </div>
          </div>
        </swiper>
      </div>
    </div>
    <ModalReadMoreLinkType v-if="openModalReadmore" />
    <ModalShare />
    <modalShowHelp />
  </div>
</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex'
  import { APP_CONFIG } from '@/utils/constants'
  import mixinsFiles from '@/components/content-files/mixinsFiles'
  import PreviewVideo from '@/components/content-files/PreviewVideo.vue'
  import PreviewPdf from '@/components/content-files/PreviewPdf.vue'
  import Previewpptx from '@/components/content-files/Previewpptx.vue'
  import PreviewImage from '@/components/content-files/PreviewImage.vue'
  import PreviewYoutube from '@/components/content-files/PreviewYoutube.vue'
  import PreviewAudio from '@/components/content-files/PreviewAudio.vue'
  import PreviewBookImg from "@/components/content-files/PreviewBookImg.vue";
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import 'swiper/dist/css/swiper.css'
  import { STORE_KEY as STORE_KEY_BOOK } from '@/modules/ebooks/_store/constants'
  const img404 = require(`@/assets/images/img_404.jpg`)
  import IconMedia from '@/modules/libraries/_components/list/IconMedia.vue'
  import { getAuth } from '@/utils/jwt'
  import { EMAIL_PUBLIC } from '@/store/auth/constants'
  import { ID_MODAL_READ_LINK_TYPE } from '@/modules/libraries/_store/constants'
  import vueCustomScrollbar from 'vue-custom-scrollbar'
  import PreviewMedia from './PreviewMedia.vue'
  import ModalShare from '@/modules/libraries/_components/detail/ModalShare.vue'
  import ModalReadMoreLinkType from '@/modules/libraries/_components/list/ModalReadMoreLinkType.vue'
  import modalShowHelp from '@/components/modal/modalShowHelp'
  import { updatecountview, apiUpdateCountdownload } from '@/store/common/api'
  import { FLE_DOWNLOAD_BEFORE } from '@/store/common/constants'

  export default {
    name: 'ModalMedia',
    mixins: [ mixinsFiles ],
    props: {
      mediaMore: Boolean
    },
    components: {
      modalShowHelp,
      vueCustomScrollbar,
      PreviewVideo,
      Previewpptx,
      PreviewImage,
      PreviewYoutube,
      PreviewAudio,
      PreviewBookImg,
      swiper, 
      swiperSlide,
      IconMedia,
      PreviewMedia,
      ModalShare,
      ModalReadMoreLinkType
    },
    data () {
      return {
        appUrl: APP_CONFIG.bookCdnUrl,
        cdnUrl: APP_CONFIG.cdnUrl,
        imgUrlCms: APP_CONFIG.urlPlatformCmsImg,
        scale: 1,
        relateMedia: [],
        mediaRelateNotdata: false,
        optionsSliderMain: this.settingSwiperMain(),
        currLinkIndex: 0,
        docTypeSlideActive: '',
        img404,
        urlImgCms: APP_CONFIG.urlPlatformCmsImg,
        indexMediaMain: 0,
        openModalReadmore: false,
        mediaMain: {},
        errorTypeId: 0,
        nameRoute: this.$route.name,

      }
    },
    computed: {
      ...mapState('common', ['docSlider', 'visiblePreviewSliderModal', 'setCountView']),
      ...mapState(STORE_KEY_BOOK, ['paramSearchRelateMedia']),
      authInfo() {
        return getAuth()
      },
      queryRoute () {
        return this.$route.query
      }
      // getDurationMedia(link) {
      //   let result = '';
      //   // Create a non-dom allocated Audio element
      //   let typeElem = this.checkVideo(link) ? 'video' : 'audio'
      //   let elm = document.createElement(typeElem);
      //   // Define the URL of the MP3 audio file
      //   elm.src = `${this.appUrl}${link}`
      //   // Once the metadata has been loaded, display the duration in the console
      //   elm.addEventListener('loadedmetadata', function(){
      //     // Obtain the duration in seconds of the audio file (with milliseconds as well, a float value)
      //     let duration = elm.duration;
      //     let minutes = parseInt(duration / 60, 10);
      //     let seconds = parseInt(duration % 60).toFixed(2);
      //     result = `${minutes}:${seconds}`;
            
      //   }, false);
      //   return result;
      // }
    },
    watch: {
      'paramSearchRelateMedia': 'getDataRelateMedia',
      'setCountView': 'fetchSetCountView',
      docSlider(newVal) {
        // console.log('AAAAAAA', newVal)
        if(newVal && newVal.bookPageLinkId) {
          this.relateMedia = [];
          this.SET_PARAM_SEARCH_RELATE_MEDIA({
            ...this.paramSearchRelateMedia,
            bookPageId: newVal.bookPageLinkId,
            pageIndex: 1
          });
        }
        if (newVal && newVal.linkPages && newVal.linkPages.length > 0) {
          this.mediaMain = newVal.linkPages[0]
        }
        // console.log('BBBBBB')
      },
      currLinkIndex(newVal) {
        // console.log('CCCC')
        if(newVal && newVal !== 0) {
          this.docTypeSlideActive = this.docSlider.linkPages[newVal].documentTypeId;
        }
      },
      docTypeSlideActive(newVal) {
        // console.log('BBBBBBB docTypeSlideActive')
        if(newVal) {
          this.SET_PARAM_SEARCH_RELATE_MEDIA({...this.paramSearchRelateMedia, typeId: newVal, pageIndex: 1});
        }
      }
    },
    mounted() {
      this.getDataRelateMedia()
      this.setMediaMain()
    },
    created (){
      this.actionCheckRouterHelp({nameRoute: this.nameRoute})
    },
    beforeDestroy() {
      this.relateMedia = [];
      this.mediaRelateNotdata = false;
    },
    methods: {
      ...mapActions('auth', ['setToggleLoginForm']),
      ...mapActions('common', ['setToggleModalDocSlider', 'setDocPreviewSlider', 'setLoading', 'acToggleModalActiveBook', 'acToggleModalShareMedia', 'acSetMediaShareInfo', 'acToggleModaShowError', 'actionCheckRouterHelp', 'actionSetCountView']),
      ...mapActions(STORE_KEY_BOOK, ['getRelateMedia']),
      ...mapMutations(STORE_KEY_BOOK, ['SET_PARAM_SEARCH_RELATE_MEDIA']),

      setMediaMain () {
        if (this.docSlider) {
          if (this.queryRoute && this.queryRoute.mediaId) {
            let indexMedia = this.docSlider.linkPages.findIndex(link => link.pageLinksId === parseInt(this.queryRoute.mediaId))
            if(indexMedia > -1) {
              this.indexMediaMain = indexMedia
              this.mediaMain = this.docSlider.linkPages[indexMedia]
            }
          } else if (this.docSlider.linkPages) {
            this.mediaMain = this.docSlider.linkPages[0]
          }
        }
      },
      fetchSetCountView () {
        // console.log('123')
        // this.setDocPreviewSlider()
      },

      handleOffModal() {
        this.setToggleModalDocSlider(false)
        this.setDocPreviewSlider({})
      },

      settingSwiperMain() {
        let self = this;
        return {
          slidesPerView: 1,
          spaceBetween: 0,
          navigation: {
            nextEl: '.ebook__next__main',
            prevEl: '.ebook__prev__main',
          },
          on: {
            slideChange: function () {
              self.currLinkIndex = this.realIndex;
            }
          }
        }
      },

      viewMedia(data) {
        let linkActive = data.isShowFree && data.isShowFree !== 0;
        if(this.authInfo && this.authInfo.email === EMAIL_PUBLIC && !data.isActived && !linkActive) {
            this.setToggleLoginForm(true);
        } else if(!linkActive && !data.isActived) {
            this.acToggleModalActiveBook(true)
        } else {
          this.setLoading(true);
          this.setDocPreviewSlider({});
          this.$emit('viewMoreMedia', data);
          this.currLinkIndex = 0;
          this.indexMediaMain = 0;
          this.setLoading(false);
        }
      },

      handleNextMedia(evt) {
        const swiperRef = this.$refs.swiper_relate.swiper;
        // const indexActive = swiperRef.isEnd;
        if(swiperRef.isEnd && !this.mediaRelateNotdata) {
          this.SET_PARAM_SEARCH_RELATE_MEDIA({...this.paramSearchRelateMedia, pageIndex: this.paramSearchRelateMedia.pageIndex + 1})
        }
      },

      handleNextMediaMain(evt) {
        const swiperMain = this.$refs.swiper_main.swiper
        this.indexMediaMain = swiperMain.realIndex
      },

      showModalReadmore () {
        if (this.openModalReadmore) {
          this.$bvModal.show(ID_MODAL_READ_LINK_TYPE)
        } else {
          this.openModalReadmore = true
          setTimeout(() => {
            this.$bvModal.show(ID_MODAL_READ_LINK_TYPE)
          }, 500);
        }
      },

      getDataRelateMedia() {
        let self = this;
        if(self.paramSearchRelateMedia.bookId && self.paramSearchRelateMedia.bookId > 0) {
          self.getRelateMedia(self.paramSearchRelateMedia).then(res => {
            if(res) {
              self.relateMedia = [...self.relateMedia, ...res];
            }
            if(res.length === 0) {
              self.mediaRelateNotdata = true;
            }
          })
        }
      },
            
      handleOffModal() {
        this.setToggleModalDocSlider(false)
        this.setDocPreviewSlider({})
      },

      getTypeMedia (link) {
        if (this.checkVideo(link)) {
          return 'Video'  
        } else if ( this.checkAudio(link) ) {
          return 'Audio'
        } else if ( this.checkGifImage(link) ) {
          return 'GIF'
        } else if ( this.checkImage(link) ) {
          return 'Ảnh'
        }
      },

     getDurationMedia (link) {
        // let result = '';
        // // Create a non-dom allocated Audio element
        // let typeElem = this.checkVideo(link) ? 'video' : 'audio'
        // let elm = document.createElement(typeElem);

        // // Define the URL of the MP3 audio file
        // elm.src = `${this.appUrl}${link}`

        // // Once the metadata has been loaded, display the duration in the console
        // elm.addEventListener('loadedmetadata', async function(){
        //     // Obtain the duration in seconds of the audio file (with milliseconds as well, a float value)
        //     let duration = elm.duration;
        //     let minutes = parseInt(duration / 60, 10);
        //     let seconds = parseInt(duration % 60);
        //     console.log('Result evt: ', `${minutes}:${seconds}`);
        //     result = await `${minutes}:${seconds}`;
            
        // }, false);

        // console.log('Result: ', result);

        // return result;
      },

      viewMediaInDocSlider (index) {
        this.indexMediaMain = index;
        this.mediaMain = this.docSlider.linkPages[index]
        // console.log('click index', this.mediaMain)
        updatecountview(this.mediaMain.pageLinksId).then(res => {
          if(res && res.status === 'success'){
            this.actionSetCountView(Math.random())
          }
        })

      },

      handleShareMedia () {
        this.acSetMediaShareInfo({...this.docSlider, ...this.docSlider.linkPages[this.indexMediaMain]})
        this.acToggleModalShareMedia(true)
      },
      openModalError () {
        if(this.nameRoute === 'exerciseDetail'){
          this.acToggleModaShowError({ isShow: true, errorTypeId: 2 })
        }
        if(this.nameRoute === 'ebook-read-book'){
          this.acToggleModaShowError({ isShow: true, errorTypeId: 1 })
        }
      },

      handleDownloadFile (link, name, id) {
        if(this.authInfo && this.authInfo.email === EMAIL_PUBLIC) {
          this.setToggleLoginForm(true);
        } else {
          apiUpdateCountdownload(id)
          this.downloadDocs(link, `${FLE_DOWNLOAD_BEFORE} ${name}`)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .count-download{
    width: 100px !important;
  }
  .count-d{
    padding-left: 5px;
  }
  .show-document{
    .inner-content{
      position: fixed;

        &.active {
        z-index: 11;
      }
    }
    .js-background-model{
      position: fixed;
        z-index: 1;
    }
  }
  .content-top, .content-center {
    position: relative;
    z-index: 10!important;
  }
  .content-center{
    height: 100vh;
    margin: 0 auto!important;
    // padding: 5vh 0;
    // background: rgba(64, 80, 94, 0.8);
  }
  .inner-img {

    &:not(.inner-type-pptx) {
     // overflow-y: auto;
     // max-height: 80vh;
     // @extend .display-flex-center;
     // height: 80vh;
    }

    &.has-book {
      // overflow-y: inherit;
    }

    &.has-more {
      // height: calc(85vh - 240px);
      height: calc(85vh - 160px);
    }

    &.inner-type-doc {
      background: #ccc;
    }

    &.inner-type-img, &.inner-type-audio {
      height: 80vh;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  #content_viewer {
    .item--audio {
      padding-top: 15%;
    }
  }
  .content-type-img, .content-type-video {
    .inner-img {
      background: transparent;
    }

    img {
      max-height: 80vh;
    }

    &.has-more {
      img {
        max-height: calc(80vh - 245px);
      }
    }

  }
  .inner-up {
    margin-left: 20px;

    @media screen and ( max-width: 575px ) {
      margin-left: 10px;
    }
  }
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba($primary_text_color, .6);
    z-index: 11;

    ~ * {
      position: relative;
      z-index: 12;
    }
  }

  .sidebar__media__list--slider {
    z-index: 12;
    // max-width: 80vw;
    // margin: 40px auto 20px;
    max-height: 30vh;

    .item {
      margin-bottom: 0!important;

      &__wrap {

        &:before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
          background: rgba(0,0,0, .0);
        }
      }

      &--audio {
        .item {
          &__media {
            padding: 5px 0 35px;
          }

          &__icon {
            left: 3%;
          }
        }
      }

      &--lock {
      }

      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,.3);
        z-index: 1;
        @extend .effect-transition-fast;
        @extend .effect-hide-hover;
      }

      &__icon {
        @extend .position-center-xy;
        z-index: 1;
        opacity: 0;
      }

      &:hover {
        &:before {
          @extend .effect-show-hover;
        }
        .item {

          &__icon {
            opacity: 1;
          }
        }
      }
    }

    .sidebar__media__list {
      &__title {
        margin: 0 0 25px;
      }
    }
  }
  .content_viewer__type {
    cursor: pointer;

    &:hover {
      @extend .secondary-color-txt;
    }
  }
  .ebook__next__0, .ebook__prev__0 {
    height: 100%;
    top: 0;
    margin: 0;
    background-position: center;
    width: 50px;
    background-color: rgba(0,0,0,.3); 
  }
  .ebook__prev__0 {
    left: 0;
    border-radius: 6px 0 0 6px;
  }
  .ebook__next__0 {
    right: 0;
    left: auto;
    border-radius: 0 6px 6px 0;
  }

  .swiper-button-prev.swiper-button-disabled, .next-main.next-main-disabled, .pre-main.pre-main-disabled, .swiper-button-next.swiper-button-disabled {
    pointer-events: auto!important;
  }
  .swiper-button-next.swiper-button-disabled, .swiper-button-prev.swiper-button-disabled, .next-main.swiper-button-disabled, .pre-main.swiper-button-disabled {
    opacity: .35;
    cursor: auto;
    pointer-events: none;
  }

  .ebook__prev__main {
    left: 0;
  }
  .ebook__next__main {
    right: 0;
  }

  @media screen and ( max-width: 575px ) {
    .sidebar__media__list {

      &--slider {
        margin: 15px auto 10px;
      }

      &__title {
        font-size: 18px;
      }
    }

    .ebook__next__0, .ebook__prev__0 {
      width: 30px;
    }
  }

  .swiper-container {
    padding-bottom: 0!important;
  }
  .next-main{
    position: absolute;
    right: 0;
    top: 40%;
    cursor: pointer;
    background: #3b4852;
    height: 120px;
    padding: 0 4px;
    border-radius: 8px;
    line-height: 120px;
    z-index: 99;
  }
  .pre-main{
    z-index: 99;
    position: absolute;
    left: 0;
    top: 40%;
    cursor: pointer;
    background: #3b4852;
    height: 120px;
    padding: 0 4px;
    border-radius: 8px;
    line-height: 120px;
  }
    .icon-arrow-right .path1:before {
    content: "\e987";
    color: white;
  }
  
  .icon-arrow-right .path2:before {
    content: "\e988";
    margin-left: -1em;
    color: white;
  }
  


  .icon-arrow-left .path1:before {
    content: "\e985";
    color: white;
  }
  .icon-arrow-left .path2:before {
    content: "\e986";
    margin-left: -1em;
    color: white;
  }

  
  .button-next-0{
    position: absolute;
    cursor: pointer;
    background: #3b4852;
    height: 150px;
    line-height: 150px;
    top: 0;
    margin: 0;
    background-position: 50%;
    width: 50px;
    background-color: rgba(0,0,0,.3);
    right: 0;
    left: auto;
    border-radius: 0 6px 6px 0;
    z-index: 99;
    padding: 0 5px;
  }
  .button-prev-0{
    position: absolute;
    cursor: pointer;
    background: #3b4852;
    height: 150px;
    line-height: 150px;
    top: 0;
    margin: 0;
    background-position: 50%;
    width: 50px;
    background-color: rgba(0,0,0,.3);
    left: auto;
    border-radius: 6px 0px 0px 6px;
    z-index: 99;
    padding: 0 5px;
  }

  .modal-head {
    padding: 15px 0;
  }

  // , .content-viewer__info
  .content-viewer, .sidebar__media__list--slider {
    margin-left: 60px;
    margin-right: 60px;
    @media screen and (max-width: 1024px){
      margin-left: 42px;
      margin-right: 42px;
    }
    @media screen and (max-width: 768px){
      margin-left: 30px;
      margin-right: 30px;
    }
    @media screen and (max-width: 575px){
      margin-left: 23px;
      margin-right: 23px;
    }
    @media screen and (max-width: 425px){
      margin-left: 10px;
      margin-right: 10px;
    }
  }
  @media screen and (max-width: 425px){
    .mobile-slide{
      margin-bottom: 80px;
    }
  }

  .content-viewer {

    &__head {
      z-index: 12;
      @extend .position-rel;
    }

    &__info {
      margin-top: 20px;

      &__action {
        @extend .display-flex;
        
        button {
          line-height: 1;
          letter-spacing: 0.03em;

          &:not(:last-child) {
            margin-right: 15px;
          }
        }

        &__help {
          padding: 0;
          width: 30px;
          height: 30px;
          @extend .display-flex-center;
          @extend .justify-content-center;
        }
      }
    }

    &__info__wrap{
      // margin-top:35px;
      // @media (min-width: 992px) and (max-width: 1599px) {
      //   margin-top:70px;
      // }
    }
  
    &.multi {
      max-height: 100%;
      overflow: hidden;

      .content-viewer {
        &__main {
          width: 68%;
        }

        &__list {
          width: 30%;
        }
      }
    }

    &.single {
      @extend .display-flex-center;
      @extend .justify-content-center;
    }

    &__list {

      &__title {
        letter-spacing: 0.03em;
      }

      &__head {
        padding: 10px 15px;
        border-bottom: 1px solid $primary_text_color;
        border-radius: 8px 8px 0 0;
      }

      &__head, &__body {
        background: rgba($primary_text_color, .5);
      }

      &__body {
        // 140px is height head & space foot
        border-radius: 0 0 8px 8px;
        // height: calc(100% - 140px);
        // height: calc(100% - 127px);
        height: calc(100% - 40px);
        overflow: auto;
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */

        &::-webkit-scrollbar {
          display: none;
        }

        .item {
          @extend .display-block;
          padding: 15px;
          @extend .display-flex;

          &.active, &:hover {
            background: rgba($primary_text_color, 1);
          }

          &__img {
            width: 35%;
            margin-right: 4%;
          }

          // &__img {
            // width: 90px;
            // height: 50px;
            // margin-right: 15px;
          // }

          &__title {
            letter-spacing: 0.03em;
          }
        }
      }
    }

    &__preview {
      
      &__head {
        max-height: 57vh;
      }

      &.multi {
        .content-viewer__preview {
          &__head, &__body {
            @extend .display-flex;
            @extend .justify-content-between;
            overflow: hidden;
          }
        }
      }
    }
  }

  @media screen and ( min-width: 992px ) and ( max-width: 1599px ) {
    .content-viewer {

      &__head {
        padding: 5px 0;
      }

      &__info {
        margin-top: 10px;
      }

      &.multi {

        .content-viewer {
          &__main {
            width: 70%;
          }

          &__list {
            width: 28%;
          }
        }
      }
    }

    .inner-img.has-more {
      height: auto;
      margin-bottom: 15px;
    }

    .media-preview {
      &__title {
        font-size: 21px;
      }

      &__type {
        font-size: 16px;
      }
    }
    .sidebar__media__list--slider {
      margin-top: 0;

      .sidebar__media__list__title {
        font-size: 19px;
        margin-bottom: 15px;
      }
    }
  }

  @media screen and ( min-width: 992px ) and ( max-width: 1199px ) {
    .content-viewer {
      &__preview {
        &.multi {
          .content-viewer__preview {

            &__head {
              max-height: 400px;
            }
          }
        }
      }
    }

    .media-preview {
      &__title {
        font-size: 26px;
      }

      &__type {
        font-size: 16px;
      }
    }
  }
  
  @media screen and ( min-width: 768px ) and ( max-width: 991px ) {
    .content-viewer {

      &.multi {
        .content-viewer {

          &__main {
            width: 65%;
          }
          &__list {
            width: 33%;
          }
        }
      }

      &__list {
        &__body {
          .item {
            &__img {
              width: 70px;
              height: 40px;
            }
          }
        }
      }
    }
  }

  @media screen and ( max-width: 767px ) {
    .content-center {
      min-height: 100vh;
    }
    .show-document .inner-content {
      height: auto;
      overflow: auto!important;
    }
    .inner-content, .content-center, .inner-img.has-more {
      height: auto;
      overflow: auto!important;
    }
    .content-viewer {

      &__info {
        &__wrap {
          display: block;
        }

        &__content {
          margin-bottom: 15px;
        }
      }

      &__preview {

        &.multi {
          display: block;
          overflow: auto;
          
          .content-viewer__preview {
            &__head {
              display: block;
              max-height: inherit;
            }
          }
        }
      }
      &.multi {
        overflow: auto;
        height: auto;
        
        .content-viewer {
          &__main, &__list {
            width: 100%;
          }
        }
      }

      &__main {
        margin-bottom: 15px;
      }

      &__list {
        &__body {
          height: 300px;
        }
      }
    }
    .media-preview__title {
      font-size: 20px;
    }
  }
  @media screen and (max-width: 575px){
    .info-content{
      display: none;
    }
    .mg-mobile{
      margin-bottom: 60px;
    }
  }
</style>